/**
 * Internal dependencies
 */
import { getLayout } from 'state/dashboard-layouts/selectors';
import getLayoutId from './get-layout-id';

export default (state) => getLayout(state, getLayoutId(state));
